/**
 * <brand-reveal> — fades/slides its direct [data-reveal] children into view
 * as they cross into the viewport. Used only inside the new homepage
 * storytelling sections; isolated from the rest of the theme's component system.
 */
class BrandReveal extends HTMLElement {
  connectedCallback() {
    const targets = this.hasAttribute('data-reveal') ? [this] : [...this.querySelectorAll('[data-reveal]')];

    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    for (const target of targets) observer.observe(target);
  }
}

customElements.define('brand-reveal', BrandReveal);
